import { style } from "@vanilla-extract/css";

import { input } from "~/components/Input.css";

export const textarea = style([
  input,
  {
    resize: "vertical",
  },
]);
